// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__16EKe","productName":"Table_productName__2v3sV"};